
import { Box, Button } from '@mui/material';


import React, { useEffect, useState } from 'react';


import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MixSearch from './MixSearch';
import DynamicSearchMenu from '../../../pages/Booking/Components/searchOptionComponents/DynamicSearchMenu';
import { searchClient, searchDestination, searchPortLoading, searchShippingLine } from '../../../actions/formAction';
import QueryMultiSelectMenu from '../../../components/filters/QueryMultiSelectMenu';



const ContainerDropdownMenu = ({ onFetchData , isClient }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const formReducer = useSelector((state) => state.form);

    // eslint-disable-next-line no-unused-vars
    const [adavancedSearchPrems, setAdavancedSearchPrems] = useState(formReducer?.data?.advancedSearches || []);

    useEffect(() => {
        if (formReducer.loading === 'succeeded') {
            setAdavancedSearchPrems(formReducer?.data?.advancedSearches || []);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formReducer.loading]);




    const handelResetFilter = () => {
        const searchParams = new URLSearchParams(location.search);

        searchParams.delete('Clients');
        searchParams.delete('Destination');
        searchParams.delete('MixSearch');
        searchParams.delete('ShippingLine');
         searchParams.delete('PortLoading');
         searchParams.delete('Status');
         searchParams.delete('BookingId');



        navigate({ search: searchParams.toString() });



    }




    return (
        <Box sx={{display:"flex",flexDirection:"column" , gap:2}}>
            <Box sx={{ pl: 2, display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'start' }}>

<QueryMultiSelectMenu
    title="Status"
    queryParam="Status"
    options={[
        { value: 'Not Arrived', label: 'Not Arrived' },
        { value: 'Arrived', label: 'Arrived' },
        { value: 'Loaded', label: 'Loaded' },
        { value: 'Departed', label: 'Departed' },
    ]}
    allLabel="All Status"
/>
               
               <DynamicSearchMenu label="Destination" queryParam="Destination" loadingKey="isLoadingDestinationData" dataKey="destination" fetchAction={searchDestination} />
              {!isClient && <DynamicSearchMenu label="Clients" paramSelectName1='name' paramSelectName2='company' queryParam="Clients" loadingKey="isLoadingClientData" dataKey="client" fetchAction={searchClient} />}
               <DynamicSearchMenu label="Port Loading" queryParam="PortLoading" loadingKey="isLoadingPortData" dataKey="portLoading" fetchAction={searchPortLoading} />
               <DynamicSearchMenu label="Shipping Line" queryParam="ShippingLine" loadingKey="isLoadingShippingLineData" dataKey="shippingLine" fetchAction={searchShippingLine} />



                <Button color='colorD' onClick={handelResetFilter}>
                    {t("ResetFilter")}
                </Button>

             <Button variant="b1" onClick={onFetchData} sx={{ minWidth: { xs: 'auto', sm: '200px' } }}>{t('FetchData')}</Button>



            </Box>
            <Box sx={{ width: { xs: '100%', md: '35%' }, mt:1 , mb:2}}>
            <MixSearch />

            </Box>

        </Box>
    );
};

export default ContainerDropdownMenu;
